module.exports = __webpack_public_path__ + "img/predicciones_isack_dm.96618f38.png";